import i18n from '@/languages'


export function getIconByDirection(direction) {
    var iconUrl = "assets/svgs/";

    if ((direction == null) || (direction == ""))
        iconUrl += "icon_loc_online_0.svg";
    else if (((direction >= 0.0) && (direction < 22.5)) || ((direction <= 360.0) && (direction > 337.5)))
        iconUrl += "icon_loc_online_0.svg";
    else if ((direction >= 22.5) && (direction <= 67.5))
        iconUrl += "icon_loc_online_45.svg";
    else if ((direction > 67.5) && (direction < 112.5))
        iconUrl += "icon_loc_online_90.svg";
    else if ((direction >= 112.5) && (direction <= 157.5))
        iconUrl += "icon_loc_online_135.svg";
    else if ((direction > 157.5) && (direction < 202.5))
        iconUrl += "icon_loc_online_180.svg";
    else if ((direction >= 202.5) && (direction <= 247.5))
        iconUrl += "icon_loc_online_225.svg";
    else if ((direction > 247.5) && (direction < 292.5))
        iconUrl += "icon_loc_online_270.svg";
    else if ((direction >= 292.5) && (direction <= 337.5))
        iconUrl += "icon_loc_online_315.svg";
    else
        iconUrl += "icon_loc_online_0.svg";

    return iconUrl;
}

export function convertDirection(direction) {
    try {
        if (direction == undefined) return i18n.t("public.unKnown");
        else if (direction == 0.0 || direction == 360.0)
            return i18n.t("direction.north");
        else if (direction > 0 && direction < 90)
            return (
                i18n.t("direction.eastNorth") +
                (90.0 - direction) +
                i18n.t("direction.degree")
            );
        else if (direction == 90) return i18n.t("direction.east");
        else if (direction > 90 && direction < 180)
            return (
                i18n.t("direction.eastSouth") +
                (direction - 90) +
                i18n.t("direction.degree")
            );
        else if (direction == 180) return i18n.t("direction.south");        
        else if (direction > 180 && direction < 270)
            return (
                i18n.t("direction.westSouth") +
                (270.0 - direction) +
                i18n.t("direction.degree")
            );
        else if (direction == 270) return i18n.t("direction.west");
        else if (direction > 270 && direction < 360)
            return (
                i18n.t("direction.westNorth") +
                (direction - 270.0) +
                i18n.t("direction.degree")
            );
        else return i18n.t("public.unKnown");
    } catch (e) {
        return i18n.t("public.unKnown");
    }
}